export function classNames(
  conditionalClasses: { [className: string]: boolean },
  ...otherClasses: Array<string | null>
): string | undefined {
  const optionalClasses = Object.entries(conditionalClasses).map(
    ([className, value]) => {
      return value ? className : null;
    }
  );

  const res = otherClasses
    .concat(optionalClasses)
    .filter(v => !!v)
    .join(' ')
    .trim();
  return res === '' ? undefined : res;
}
